import { useState } from "react"
import useStore from "../../../../store"
import FormInput from "../../../common/FormInput"
import { HappyButton, NeutralButton } from "../../../common/Buttons"
import Spinner from "../../../common/Spinner"

const INITIAL_VALUES = {
  first_name: '',
  last_name: '',
  title: '',
  email: '',
  cell_phone: '',
}

export default function PersonForm({ dealerId, onClose }) {
  const createPerson = useStore((state) => state.createPerson)
  const isCreating = useStore((state) => state.isCreatingPerson)
  const [inputValues, setInputValues] = useState(INITIAL_VALUES)
  const [errors, setErrors] = useState({})

  const handleChange = (field) => (e) => {
    setInputValues({ ...inputValues, [field]: e.target.value })
    if (errors[field]) setErrors({ ...errors, [field]: false })
  }

  const validate = () => {
    const newErrors = {}
    if (!inputValues.first_name.trim()) newErrors.first_name = true
    if (!inputValues.last_name.trim()) newErrors.last_name = true
    if (!inputValues.email.trim()) newErrors.email = true
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async () => {
    if (!validate()) return

    await createPerson(dealerId, inputValues)
    onClose()
  }

  return (
    <div className="flex flex-col gap-3 p-2">
      <div className="flex gap-3">
        <div className="flex-1">
          <FormInput
            title="First Name"
            value={inputValues.first_name}
            onChange={handleChange('first_name')}
            isErrored={!!errors.first_name}
          />
        </div>
        <div className="flex-1">
          <FormInput
            title="Last Name"
            value={inputValues.last_name}
            onChange={handleChange('last_name')}
            isErrored={!!errors.last_name}
          />
        </div>
      </div>

      <FormInput
        title="Title"
        value={inputValues.title}
        onChange={handleChange('title')}
      />

      <FormInput
        title="Email"
        value={inputValues.email}
        onChange={handleChange('email')}
        isErrored={!!errors.email}
      />

      <FormInput
        title="Cell Phone"
        value={inputValues.cell_phone}
        onChange={handleChange('cell_phone')}
      />

      <div className="flex justify-evenly items-center mt-2">
        {isCreating ? (
          <Spinner color="green" />
        ) : (
          <>
            <HappyButton
              text="Create Person"
              onClick={handleSubmit}
              style="my-4 w-30 justify-items-center"
            />
            <NeutralButton
              text="Cancel"
              onClick={onClose}
              style="my-4 w-30 justify-items-center"
            />
          </>
        )}
      </div>
    </div>
  )
}
